export default __webpack_public_path__ + "static/countryBackground-acf1fac9898eba8092419aed6bbea1eb.png";